// extracted by mini-css-extract-plugin
export default {"downDrawer":"Products_downDrawer__mOMR3","downSvg":"Products_downSvg__LX+A+"};